<template>
    <LayoutMain>
        <template slot="body">
            <p class="page_section__title t-h--2 has-text-centered is-uppercase"> {{$t('Termos e Condições')}}</p>
            <br>
            <p>
              {{$t('A CONSTÁLICA - ELEMENTOS CONSTRUÇÃO METÁLICA, S.A. (adiante, CONSTÁLICA), com sede na Zona Industrial Monte Cavalo, Lt 25, 3670 -273 Vouzela e NIPC 506927563 é proprietária da presente página na Internet. Este site tem como finalidade a informação e promoção dos produtos e/ou serviços nela divulgados.')}}
            </p>
            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Atenção')}}
              </p>
            </div>
            <p>
              {{$t('Solicita-se a leitura de todos os termos e das seguintes condições antes de utilizar o presente site. Registando-se neste site e seleccionando o ícone que confirma a aceitação das condições aqui indicadas, os utilizadores sujeitam-se aos termos e às condições do presente acordo que, aliás, constituem um contrato estipulado entre o utilizador e a CONSTÁLICA.')}}
            </p>
            <p>
              {{$t('Se não aceitar os presentes termos e condições, deverá abster-se de usar este site.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Objeto')}}
              </p>
            </div>

            <p>
              {{$t('Os presentes Termos e Condições regulam a utilização do site da CONSTÁLICA.')}}
            </p>
            <p>
              {{$t('O site fornece informação relativa a um conjunto de produtos e serviços prestados pela CONSTÁLICA, bem como disponibiliza uma ferramenta de cálculo denominada MAXBOX.')}}
            </p>
            <p>
              {{$t('Ao iniciar o processo de utilização do site o Utilizador declara, expressamente, ter lido e aceite livremente os presentes Termos e Condições, sem qualquer reserva.')}}
            </p>
            <p>
              {{$t('Com a aceitação dos presentes Termos e Condições, o Utilizador declara que é maior de 18 anos de idade e que dispõe de capacidade legal para celebrar contratos.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Termos e Condições')}}
              </p>
            </div>

            <p>
              {{$t('O Utilizador será inteiramente responsável pelo acesso e uso correcto do Site, submetendo-se à legislação vigente aplicável, nacional ou internacional, assim como aos princípios de boa fé, moral e ordem pública, e assumindo o compromisso de cumprir diligentemente qualquer instrução adicional que, em relação aos referidos uso e acesso ao Site, possa ser-lhe dada pela CONSTÁLICA.')}}
            </p>
            <p>
              {{$t('O Utilizador obriga-se a utilizar o Site e os seus conteúdos de forma ponderada, de acordo com as possibilidades e finalidades para que o mesmo foi concebido. A CONSTÁLICA não assumirá qualquer responsabilidade, directa ou indirecta, derivada do uso incorrecto do Site ou dos seus conteúdos por parte do Utilizador, assumindo este sempre, sob a sua inteira responsabilidade, as consequências, danos ou acções que possam resultar do seu acesso ou uso do Site e conteúdos nele alojados, assim como da sua reprodução ou comunicação.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA fará o razoavelmente possível para vigiar a legalidade dos conteúdos, imagens, opiniões e qualquer outra informação que se comunique através do Site.')}}
            </p>
            <p>
              {{$t('O utilizador aceita expressamente que usa o presente site por sua conta e risco. A CONSTÁLICA não garante que o site será ininterrupto ou isento de erros; nem dá qualquer garantia relativamente aos resultados que venham a ser obtidos da utilização do mesmo, ou relativamente à exactidão, fiabilidade ou teor de qualquer informação, serviço ou mercadoria mencionada através do site.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Registo')}}
              </p>
            </div>

            <p>
              {{$t('Para utilizar algumas das funcionalidades presentes no Site, nomeadamente a ferramenta de cálculo denominada MAXBOX, o Utilizador terá que efetuar um Registo e criar a sua Conta de Utilizador através do processo de registo disponível no site.')}}
            </p>
            <p>
              {{$t('Nos termos referidos no parágrafo anterior, o Utilizador deverá indicar os seguintes dados:')}}
            </p>
            <ol type="a">
              <li>{{$t('Nome (primeiro e último);')}}</li>
              <li>{{$t('E-mail;')}}</li>
              <li>{{$t('Palavra-passe/password de acesso;')}}</li>
              <li>{{$t('Empresa;')}}</li>
              <li>{{$t('País;')}}</li>
            </ol>
            <p>
              {{$t('O Utilizador é responsável pela veracidade, exatidão e licitude dos dados fornecidos no momento do Registo, assim como pela sua atualização.')}}
            </p>
            <p>
              {{$t('Embora a CONSTÁLICA desenvolva todos os esforços para manter as informações dos Utilizadores atualizadas e exatas, sempre que surja alguma alteração sob os dados pessoais fornecidos pelo Utilizador, este deverá entrar em contacto com a CONSTÁLICA, de modo escrito, através do email maxbox@constalica.com, por forma a solicitar a atualização ou retificação dos seus dados pessoais.')}}
            </p>
            <p>
              {{$t('O Utilizador aceita que os dados de acesso à Conta de Utilizador só poderão ser utilizados pelo Utilizador, não sendo permitido a partilha de dados de acesso por várias pessoas.')}}
            </p>
            <p>
              {{$t('O Utilizador é o único responsável pela segurança e bom uso da sua palavra-passe, devendo modificar a mesma regularmente, não existindo por parte da CONSTÁLICA qualquer responsabilidade pelo uso inadequado ou perda da palavra-passe.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Responsabilidade')}}
              </p>
            </div>

            <p>
              {{$t('O serviço é fornecido tal como é apresentado online sem garantias de qualquer natureza, quer expressas ou implícitas, incluindo, garantias de direito de propriedade ou garantias implícitas de negociabilidade ou de adequação a um fim específico.')}}
            </p>
            <p>
              {{$t('A exclusão da responsabilidade da CONSTÁLICA aplica-se a quaisquer perdas e danos ou prejuízos causados por qualquer falha de desempenho, erro, omissão, interrupção, eliminação, deficiência, atraso de funcionamento ou transmissão, vírus informático, avaria de linha de comunicação, roubo ou destruição ou acesso não autorizado, alteração ou utilização de registo. O utilizador aceita especificamente que a CONSTÁLICA não é responsável por condutas difamatórias, ofensivas ou ilegais por parte de outros utilizadores ou terceiros, e que o risco de danos daí decorrentes é da inteira responsabilidade do utilizador.')}}
            </p>
            <p>
              {{$t('Nenhuma pessoa ou entidade implicada na criação, produção ou distribuição do presente site, ou no seu software, será responsável por quaisquer perdas e danos, directos ou indirectos, decorrentes da utilização do mesmo. O Utilizador aceita que estas disposições se aplicam a todos os conteúdos incluídos no site.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA reserva-se o direito de proceder judicialmente contra qualquer indivíduo ou instituição que tente obter um acesso por vias ilícitas.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Direitos de propriedade intelectual')}}
              </p>
            </div>

            <p>
              {{$t('A CONSTÁLICA é a proprietária exclusiva de todos os direitos de propriedade intelectual relativos ao Site e aos Serviços prestados através do mesmo.')}}
            </p>
            <p>
              {{$t('Todos os conteúdos publicados neste site, incluindo textos, ilustrações, vídeos, imagens, marcas, logótipos, códigos fontes, são protegidos pela legislação de propriedade intelectual, nomeadamente, por direito de autor e por direitos de propriedade industrial, sendo a sua propriedade ou licença, titulada pela CONSTÁLICA, não podendo os mesmos ser copiados, imitados ou usados, total ou parcialmente, sem a autorização prévia, por escrito, da CONSTÁLICA ou do titular do direito de propriedade intelectual aplicável, o que o Utilizador reconhece e aceita.')}}
            </p>
            <p>
              {{$t('O Utilizador compromete-se a não realizar qualquer utilização abusiva dos conteúdos presentes no site, não podendo os mesmos, no todo ou em parte, ser reproduzidos, representados, divulgados ou armazenados de qualquer forma, nem utilizar ferramentas de software para recolha de conteúdos protegidos, nomeadamente, robôs, crawlers ou outros mecanismos automáticos.')}}
            </p>
            <p>
              {{$t('O Utilizador não copiará, traduzirá, desmontará ou descompilará, nem criará ou tentará criar, por engenharia inversa ou de outra forma, o código fonte e o código objeto do site e dos serviços, assim como de ferramentas e aplicações de terceiros e do software associado à operacionalidade do site e dos serviços, nem removerá quaisquer avisos de confidencialidade ou de propriedade intelectual.')}}
            </p>
            <p>
              {{$t('A utilização do site pelo Utilizador não constituirá ou implicará a transferência de quaisquer direitos de propriedade intelectual de que seja titular a CONSTÁLICA.')}}
            </p>
            <p>
              {{$t('O Utilizador não pode, durante ou após o término da utilização do site, de nenhum modo, disputar os direitos de propriedade intelectual da CONSTÁLICA, comprometendo-se ainda a não adquirir e ou utilizar, mesmo que de forma tentada, por qualquer modo, incluindo, mas não limitando, por aquisição onerosa ou gratuita, permuta, licenciamento, aluguer, registo ou depósito dos direitos de propriedade intelectual da CONSTÁLICA.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Dados Pessoais')}}
              </p>
            </div>

            <p>
              {{$t('A CONSTÁLICA, enquanto responsável pelo tratamento de dados pessoais, respeita a sua privacidade.')}}
            </p>
            <p>
              {{$t('Todo e qualquer dado pessoal recolhido no site será mantido de forma confidencial e não será vendido, comunicado ou, de alguma forma, reutilizado por terceiros sem a sua autorização. Quaisquer dados pessoais que nos sejam fornecidos serão tratados de acordo com a legislação relevante, com as melhores práticas e assegurando todas as medidas de segurança técnica e organizativa adequadas para proteção dos mesmos.')}}
            </p>
            <p>
              {{$t('O Utilizador, enquanto titular de dados pessoais, poderá exercer os direitos que a legislação lhe atribui em matéria de proteção de dados – nomeadamente, direito de acesso, de retificação, ao apagamento, à limitação, de oposição e à portabilidade dos dados –, mediante comunicação escrita para o seguinte e-mail: maxbox@constalica.com, sem prejuízo do direito de apresentar reclamação à Autoridade de Controlo Nacional – a Comissão Nacional de Proteção de Dados (www.cnpd.pt).')}}
            </p>
            <p>
              {{$t('Para mais informações sobre a forma como tratamos os seus dados pessoais, deverá consultar a nossa Política de Privacidade, sem prejuízo dos avisos constantes nos locais próprios.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Alterações ao serviço e aos Termos e Condições Gerais de Utilização')}}
              </p>
            </div>

            <p>
              {{$t('A CONSTÁLICA poderá a todo o tempo modificar, suspender ou fazer cessar o serviço, com carácter meramente temporário ou definitivo, sem que por isso haja lugar a qualquer compensação aos Utilizadores ou a quaisquer terceiros.')}}
            </p>
            <p>
              {{$t('Os presentes Termos e Condições Gerais de Utilização são objeto de revisões regulares pela CONSTÁLICA, podendo ser atualizados ou alterados a todo o momento.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('Jurisdição')}}
              </p>
            </div>

            <p>
              {{$t('Os presentes Termos e Condições regem-se e são interpretados de acordo com a Lei Portuguesa. É competente para dirimir quaisquer conflitos que resultem da interpretação e aplicação dos presentes Termos e Condições o Tribunal de Viseu com expressa renúncia a qualquer outro.')}}
            </p>
            
        </template>
    </LayoutMain>
</template>

<script>
import LayoutMain from "../layouts/l-main.vue";

export default {

  components: {
    LayoutMain,
  },
  data() {
    return {
    };
  },
  computed: {
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
p {
  padding:10px 50px;
}

ol {
  padding-left: 100px;
}

.page_section__title{
  font-size: 20px !important;
  padding:30px 20px 10px 20px;
}

.page_section {
  position: relative;

  &:not(:last-child) {
    margin-bottom: 32px;
  }

  &__header {
    padding: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #d0d0d0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__body {
    padding: 8px;
  }
}
</style>
